// extracted by mini-css-extract-plugin
module.exports = {"Pic":"HangmanPic_Pic__YiNh7"};